import { render, staticRenderFns } from "./CertificationsSection.vue?vue&type=template&id=93c05158&scoped=true&"
import script from "./CertificationsSection.vue?vue&type=script&lang=js&"
export * from "./CertificationsSection.vue?vue&type=script&lang=js&"
import style0 from "./CertificationsSection.vue?vue&type=style&index=0&id=93c05158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c05158",
  null
  
)

export default component.exports